import { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import './SummaryOffer.css';
import IconButton from '@mui/material/IconButton';
import axiosInstance from '../../../Config/axiosInstance';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';

function SummaryOffer() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const formatNumber = (value, locale = 'ro-RO') => {
    if (value === null || value === undefined || value === '') return '';

    const n = Number(value);
    if (Number.isNaN(n)) return '';

    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get('summary-offer/');

        const data = response.data.map((item) => {
          const total =
            item.total_system !== null &&
            item.total_system !== undefined
              ? `${formatNumber(item.total_system)} ${item.system_currency || ''}`.trim()
              : '—';

          return {
            id: item.offer_id,
            codOferta: item.offer_code || '—',
            projectCode: item.project_code || '—',
            total,
            client: item.client || '—',
          };
        });

        const sortedData = data.sort((a, b) => b.id - a.id);
        setRows(sortedData);
      } catch (error) {
        console.error(
          'Eroare la obținerea datelor:',
          error.response ? error.response.data : error.message
        );
      }
    };

    fetchData();
  }, []);

  const columns = [
    { field: 'codOferta', headerName: 'Offer Code', flex: 1, minWidth: 170 },
    { field: 'projectCode', headerName: 'Project Code', flex: 1, minWidth: 270 },
    { field: 'total', headerName: 'Total System', flex: 1, minWidth: 270 },
    { field: 'client', headerName: 'Client', flex: 2, minWidth: 200 },
    {
      field: 'action',
      headerName: 'Action',
      flex: 0.5,
      minWidth: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() =>
            navigate(`/project-budget/summary-offer/summary-offer-details/${params.row.id}`)
          }
        >
          <VisibilityIcon sx={{ color: '#1976d2' }} />
        </IconButton>
      )
    }
  ];

  return (
    <div className="summary-offer-page">
      <div className="table-container">
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            sorting: {
              sortModel: [{ field: 'id', sort: 'desc' }]
            },
            pagination: {
              paginationModel: { pageSize: 10 },
            },
          }}
          disableRowSelectionOnClick
          sx={{
            "& .MuiDataGrid-cell:focus": { outline: "none" },
            "& .MuiDataGrid-cell:focus-within": { outline: "none" },
            "& .Mui-selected:hover": { backgroundColor: "transparent !important" }
          }}
          pageSizeOptions={[10, 20, 25]}
          rowHeight={40}
        />
      </div>
    </div>
  );
}

export default SummaryOffer;